/**
 *
 * The Control Script for the Modal (JS)
 *
 *
 */

(function() {

	const openElements = document.querySelectorAll('.item-research .main');
	if (! openElements.length) return;

	const closeElements = document.querySelectorAll('.item-modal .modal .close');
	if (! closeElements.length) return;

	const modalElements = document.querySelectorAll('.item-modal .modal');
	if (! modalElements.length) return;

	const centerAreaElements = document.querySelectorAll('.item-modal .modal .center-area');
	if (! centerAreaElements.length) return;

	const autoScrollElements = document.querySelectorAll('.list-item-research');

	const backToTopElement = document.getElementById('back-to-top');


	// -------------------------------------------------------------------------


	for (let i = 0; i < openElements.length; i += 1) {
		openElements[i].addEventListener('click', openEvent, false);
	}

	for (let i = 0; i < closeElements.length; i += 1) {
		closeElements[i].addEventListener('click', function(e) {
			const targetElement  = e.currentTarget.closest('.modal');
			closeEvent(targetElement);
		}, false);
	}

	for (let i = 0; i < centerAreaElements.length; i += 1) {
		centerAreaElements[i].addEventListener('click', function(e) {
			e.stopPropagation();
		}, false);
	}


	for (let i = 0; i < modalElements.length; i += 1) {
		modalElements[i].addEventListener('click', function(e) {
			const targetElement  = e.currentTarget;
			closeEvent(targetElement);
		}, false);
	}

	window.addEventListener('resize', function() {
		for (let i = 0; i < modalElements.length; i += 1) {
			onScroll(modalElements[i]);
		}
	}, { passive: true });

	// -------------------------------------------------------------------------


	function openEvent(e) {

		for (let i = 0; i < autoScrollElements.length; i += 1) {
			autoScrollElements[i].style.animationPlayState = 'paused';
		}

		const targetId       = e.currentTarget.dataset.modalId;
		const scrollBarWidth = window.innerWidth - document.body.clientWidth;

		for (let i = 0; i < modalElements.length; i += 1) {
			const modalId = modalElements[i].dataset.modalId;
			if (targetId === modalId) {
				document.body.style.overflow            = 'hidden';
				document.body.style.paddingRight        = scrollBarWidth + 'px';
				backToTopElement.style.marginRight      = scrollBarWidth + 'px';
				document.documentElement.style.overflow = 'hidden';

				addEventListenerToModal(modalElements[i]);
				onScroll(modalElements[i]);

				modalElements[i].classList.add('open');
				setTimeout(() => {
					modalElements[i].classList.add('visible');
				}, 100);
				break;
			}
		}
	}

	function closeEvent(element) {

		element.classList.remove('visible');
		setTimeout(() => {
			element.classList.remove('open');
			document.body.removeAttribute('style');
			document.documentElement.removeAttribute('style');
			backToTopElement.removeAttribute('style');
		}, 200);


		removeEventListenerFromModal(element);

		for (let i = 0; i < autoScrollElements.length; i += 1) {
			autoScrollElements[i].style.animationPlayState = 'running';
		}

	}


	// -----------------------------------------------------------------------------


	function addEventListenerToModal(targetElement) {

		targetElement.addEventListener('scroll', listenerForModal, { passive: true });

		if ('ontouchstart' in window) {
			targetElement.addEventListener('touchmove', listenerForModal, { passive: true });
		}
	}

	function removeEventListenerFromModal(targetElement) {
		targetElement.removeEventListener('scroll', listenerForModal);

		if ('ontouchstart' in window) {
			targetElement.removeEventListener('touchmove', listenerForModal);
		}
	}

	function listenerForModal(e) {
		onScroll(e.currentTarget);
	}

	// -----------------------------------------------------------------------------


	function onScroll(targetElement) {
		const btn = document.querySelectorAll('.close');
		if (btn.length === 0) return;

		let bottom;
		if (window.innerWidth < 600) {
			bottom = convertRemToPx(2.275);
		} else {
			bottom = convertRemToPx(2.5);
		}

		for (let i = 0; i < btn.length; i += 1) {

			const viewBottomY = window.innerHeight - bottom;
			const bottomPositionOfParent = btn[i].parentNode.getBoundingClientRect().bottom;
			if (viewBottomY < bottomPositionOfParent) {
				btn[i].style.transform = 'translateY(-' + (bottomPositionOfParent - viewBottomY) + 'px)';
			} else {
				btn[i].removeAttribute('style');
			}
		}
	}
}());

function convertRemToPx(rem) {
	var fontSize = getComputedStyle(document.documentElement).fontSize;
	return rem * parseFloat(fontSize);
}
